var _path, _path2, _path3, _path4, _path5, _path6;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBuildings(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 18,
    viewBox: "0 0 17 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M7.16254 3.33331C7.10588 3.54581 7.08464 3.77956 7.08464 4.04165V6.16665H3.54297V4.74998C3.54297 3.97081 4.18047 3.33331 4.95964 3.33331H7.16254Z",
    fill: "#82898F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.08464 13.9584V6.16669H3.54297C2.1263 6.16669 1.41797 6.87502 1.41797 8.29169V13.9584C1.41797 15.375 2.1263 16.0834 3.54297 16.0834H9.20964C7.79297 16.0834 7.08464 15.375 7.08464 13.9584ZM4.78255 12.5417C4.78255 12.8321 4.54172 13.0729 4.2513 13.0729C3.96089 13.0729 3.72005 12.8321 3.72005 12.5417V9.70835C3.72005 9.41794 3.96089 9.1771 4.2513 9.1771C4.54172 9.1771 4.78255 9.41794 4.78255 9.70835V12.5417Z",
    fill: "#82898F"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M9.91536 16.0834H9.20703C7.79036 16.0834 7.08203 15.375 7.08203 13.9584V4.04169C7.08203 2.62502 7.79036 1.91669 9.20703 1.91669H13.457C14.8737 1.91669 15.582 2.62502 15.582 4.04169V13.9584C15.582 15.375 14.8737 16.0834 13.457 16.0834H12.7487",
    fill: "#82898F"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M12.7513 13.25V16.0834H9.91797V13.25C9.91797 12.8604 10.2367 12.5417 10.6263 12.5417H12.043C12.4326 12.5417 12.7513 12.8604 12.7513 13.25Z",
    fill: "#82898F"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M9.91797 10.2396C9.62755 10.2396 9.38672 9.99877 9.38672 9.70835V6.16669C9.38672 5.87627 9.62755 5.63544 9.91797 5.63544C10.2084 5.63544 10.4492 5.87627 10.4492 6.16669V9.70835C10.4492 9.99877 10.2084 10.2396 9.91797 10.2396Z",
    fill: "#82898F"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M12.75 10.2396C12.4596 10.2396 12.2188 9.99877 12.2188 9.70835V6.16669C12.2188 5.87627 12.4596 5.63544 12.75 5.63544C13.0404 5.63544 13.2812 5.87627 13.2812 6.16669V9.70835C13.2812 9.99877 13.0404 10.2396 12.75 10.2396Z",
    fill: "#82898F"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBuildings);
export default __webpack_public_path__ + "static/media/buildings.b2e4c396.svg";
export { ForwardRef as ReactComponent };